import { render } from "./BusinessMainView.vue?vue&type=template&id=df56aaa6"
import script from "./BusinessMainView.vue?vue&type=script&lang=js"
export * from "./BusinessMainView.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__